import { createContext } from 'react';

export const WebViewContext = createContext<boolean>(false);
